import React from "react";

import SvgStars02 from "@uui/Stars02";

import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import type { ActionItemChipStatus } from "@app/common/types";

import {
  AUTO_ACTION_ITEM_STATUSES,
  ACTION_ITEM_STATUS_CONFIG,
} from "../constants/statusChips";

type ChipProps = TypographyProps & {
  status: ActionItemChipStatus;
  canEdit: boolean;
};

const Chip = styled<React.FC<ChipProps>>(
  ({ status: _s, canEdit: _c, ...props }) => (
    <Typography variant="labelMed" {...props} />
  )
)(({ theme, status, canEdit }) => ({
  padding: "2px 4px",
  borderRadius: "4px",
  lineHeight: 16 / 12,
  display: "inline-flex",
  width: "fit-content",
  marginRight: theme.spacing(0.5),
  alignItems: "center",
  fontFamily: theme.typography.fontFamilySecondary,
  backgroundColor: ACTION_ITEM_STATUS_CONFIG[status].background.main,
  color: "#fff",
  svg: {
    color: theme.palette.transparent.white[60],
  },
  ...(canEdit && {
    "&:hover": {
      cursor: "pointer",
      backgroundColor: ACTION_ITEM_STATUS_CONFIG[status].background.hover,
    },
  }),
}));

const StatusChip = ({
  status,
  onClick,
  canEdit = false,
}: {
  status: ActionItemChipStatus;
  onClick?: React.MouseEventHandler<HTMLElement>;
  canEdit?: boolean;
}) => {
  const handleClick: React.MouseEventHandler<HTMLSpanElement> = (e) => {
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <Chip
      status={status}
      canEdit={canEdit}
      onClick={onClick && canEdit ? handleClick : undefined}
    >
      {AUTO_ACTION_ITEM_STATUSES.includes(status) && (
        <SvgStars02 sx={{ fontSize: "inherit", mr: 0.25 }} />
      )}
      {ACTION_ITEM_STATUS_CONFIG[status].label}
    </Chip>
  );
};

export default StatusChip;
